import * as config from '../../../config';
import { sendPost } from '@eqs/cms-svelte-irtools/api';
import { ALLOWED_FIELDS_CONTACT_DATA } from './constants';
import { filterOutFields, removeEmptyFields } from './ops';
import { API_REQUEST_URL, SUBSCRIPTION_URL } from '../../../utils/constants';
export const createSubscription = async (data) => {
    //filter and remove empty or illegal fields
    const formattedData = removeEmptyFields(filterOutFields(data, ALLOWED_FIELDS_CONTACT_DATA));
    const url = `${API_REQUEST_URL}/${SUBSCRIPTION_URL}`;
    const response = await sendPost(url, {
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json+ld'
        },
        body: JSON.stringify(Object.assign(Object.assign({}, formattedData), { companyId: config.COMPANY_ID, locale: formattedData.locale || config.LOCALE }))
    }).then(async (res) => {
        return (await res.json());
    });
    if (response.status === true) {
        return true;
    }
    throw new Error(response['hydra:description'] || response['detail']);
};
